<template>
  <figure v-if="mediaExists" class="media">
    <img
      class="media-image"
      v-if="isImage"
      :src="imageUrl"
      :alt="$t('media.image-alternative-text')"
      @load="$emit('load')"
    />
    <p v-else class="media-error">{{ $t('media.unkown-type-error') }}</p>
  </figure>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    mediaExists() {
      return this.data.type !== 0 && this.data.type_id !== null
    },
    isImage() {
      return this.data.type === 1
    },
    imageUrl() {
      return `${this.$config.dynCdnImgUrl}${this.data.type_id}`
    },
  },
}
</script>

<style scoped>
.media {
  display: block;
  width: 100%;
  margin: 1em auto;
}
.media-image {
  display: block;
  width: 100%;
  height: auto;
}
.media-error {
  background: tomato;
  padding: 1em 2em;
  border-radius: 0.3em;
}
</style>
